<template>
  <footer class="footer">
    <div class="container-fluid">
      <ul class="nav">
        <li class="nav-item">
          <a
            href="http://call-q.solutions/"
            target="_blank"
            rel="noopener"
            class="nav-link"
          >
            Call-Q Homepage
          </a>
        </li>
        <li class="nav-item">
          <a>Licenced to:  {{$store.getters.csProperties.clientName}}</a>
        </li>
      </ul>

      <div class="copyright">
        {{$store.getters.csProperties.applicationName}} &copy; {{ year }} Call-Q. Version {{$store.getters.csProperties.version}}
      </div>
    </div>
  </footer>
</template>
<script>

  export default {
    data() {
      return {
        year: new Date().getFullYear(),
      };
    },
  };
</script>
<style></style>
